import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { MailExtractionResult } from '../db/MailExtractionResult.js';
import { getMailProcessing } from './getMailProcessing.js';

export const getMailExtractionResult = registerQuery({
  type: () => MailExtractionResult,
  operationName: 'getMailExtractionResult',
  resolve: (mailID: string) => {
    return async (gqlFields: BaseQLSelectionSet<MailExtractionResult>) => {
      const mailProcessing = await getMailProcessing(mailID)({ _id: 1, extractionResult: gqlFields });
      return mailProcessing?.extractionResult ?? null;
    };
  },
  params: [{ name: 'mailID', type: () => String }],
});
